import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    DriverCode:0,
    FirstName:'',
    MiddleName:'',
    LastName:'',
    Location:'',
    DOB:new Date(),
    FullName:'',
    LicenseNo:'',
    IssueDate:new Date(),
    ExpiryDate:new Date(),
    LicenseType:'',
    Type:'',
    InActive:'N',
    Nationality:'',
    SMSName:'',
    ContactNo:'',
    WMS:'N',
  },

 
   
};

const SliceDriver = createSlice({
  name: "SliceDriver",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_Driver_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_Driver_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_Driver_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_Driver_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.Location = action.payload.Location;
      state.value.HeadObject.LicenseType = action.payload.LicenseType; 
      state.value.HeadObject.Type = action.payload.Type;
      state.value.HeadObject.Nationality = action.payload.Nationality;
    } ,
    Set_Driver_HeadObject_CBM_Set: (state, action) => {
      state.value.HeadObject.CBM = action.payload.CBM; 
    } 
  },
});

export const {
  Set_Driver_Init,
  Set_Driver_HeadObject_Set, 
  Set_Driver_HeadObject_Init, 
  Set_Driver_HeadObject_New_Set,
  Set_Driver_HeadObject_CBM_Set
} = SliceDriver.actions;
export default SliceDriver.reducer;
